import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Button from '../../../../components/Button'
import Loader from '../../../../components/Loaders/Loader'

import useStyles from './styles'

function ButtonIcon({ Icon: IconImage, color, hasBorder = false, isLoading, className, iconClass, ...props }) {
  // wrapper for SVG icons with adding basic reusable styles and options
  const classes = useStyles({ color, hasBorder })

  return (
    <Button type="button" className={classnames(classes.btnIcon, className)} disabled={isLoading} {...props}>
      {isLoading ? <Loader /> : <IconImage className={iconClass} />}
    </Button>
  )
}

ButtonIcon.propTypes = {
  className: PropTypes.string,
  iconClass: PropTypes.string,
  type: PropTypes.string,
  color: PropTypes.string,
  hasBackground: PropTypes.bool,
  Icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
}

export default ButtonIcon
